import { NgModule } from '@angular/core';

import { AbbreviatePipe } from 'Angular/features/pipes/string/abbreviate.pipe';
import { WordBreakPipe } from 'Angular/features/pipes/string/word-break.pipe';

@NgModule({
    imports: [],
    declarations: [AbbreviatePipe, WordBreakPipe],
    exports: [AbbreviatePipe, WordBreakPipe],
})
export class StringPipesModule {}
